import './Toggle.css';

import React from 'react';

const DEFAULT_HEIGHT = 40;
const BASE_FONT_SIZE = 15;

interface ToggleProps {
  onClick: () => void
  disabled?: boolean | undefined
  checked: boolean
  onText: string
  offText: string
  height?: number
}

export const Toggle = ({ onClick, disabled = false, checked, onText, offText, height = DEFAULT_HEIGHT }: ToggleProps): JSX.Element => {
  const fontSize = `${height / DEFAULT_HEIGHT * BASE_FONT_SIZE}px`;

  return (
    <div className={`toggle ${disabled ? 'disabled' : ''}`} onClick={onClick} style={{ fontSize }}>
      <input type="checkbox" className="checkbox" checked={checked} readOnly/>
      <div className="toggle-content" data-ontext={onText} data-offtext={offText}>
        <span className="toggle-slider"></span>
      </div>
      <div className="toggle-background"></div>
    </div>
  );
};
